<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h6 class="fs-5">{{ 'irrigation_water_system' | translation }}</h6>
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>{{ 'irrigation_water_system' | translation }}</mat-label>
    <mat-select formControlName="water_system">
      <mat-option *ngFor="let systemNum of waterSystemsNums" [value]="systemNum">
        {{ 'irrigation_water_system' | translation }} {{ systemNum + 1 }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <h6 class="fs-5">{{ 'reports_fertilizer' | translation}}</h6>
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>{{ 'reports_fertilizer' | translation }}</mat-label>
    <mat-select formControlName="fertilizer">
      <mat-option [value]="0">{{ 'reports_acid' | translation }}</mat-option>
      <mat-option *ngFor="let num of [1,2,3,4,5,6,7,8,9]" [value]="num">
        {{ 'irrigation_fertilizer' | translation }} {{ num }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <h6 class="fs-5">{{ 'reports_date_range' | translation }}</h6>
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>{{ 'reports_date_range' | translation }}</mat-label>
    <mat-date-range-input [rangePicker]="picker" formGroupName="dateRange">
      <input matStartDate formControlName="startDate" placeholder="{{ 'start_date' | translation }}">
      <input matEndDate formControlName="endDate" placeholder="{{ 'end_date' | translation }}">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <h6 class="fs-5">{{ 'reports_costs' | translation }}</h6>
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>{{ 'reports_costs' | translation }}</mat-label>
    <input matInput formControlName="cost" type="number" placeholder="0.00" step="0.01" min="0.01">
  </mat-form-field>

  <div class="d-flex justify-content-end mt-3">
    <button type="button" class="btn btn-primary me-2" (click)="cancel()">
      {{ 'cancel' | translation }}
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="!form.valid">
      {{ 'save' | translation }}
    </button>
  </div>
</form>
